var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 197,
    viewBox: "0 0 197 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.4014 80.8536C84.6937 83.079 78.6282 92.7526 80.8536 102.46C83.079 112.168 92.7526 118.234 102.46 116.008C112.168 113.783 118.234 104.109 116.008 94.4014C113.783 84.6937 104.109 78.6281 94.4014 80.8536ZM134.365 174.476L99.2101 182.535L84.8831 120.038L22.386 134.365L14.327 99.2101L76.8241 84.8831L62.4971 22.3859L97.6517 14.327L111.979 76.8241L174.476 62.4971L182.535 97.6517L120.038 111.979L134.365 174.476Z",
    fill: "#D2FF3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group (1).96328e4b8e150a506ad4bbedeba1ed1b.svg";
export { ForwardRef as ReactComponent };